import { createContext } from "react";

export type Theme = "dark" | "light" | "system";

// ThemeProvider's default useStore key — shared with theme-init-script.ts.
export const THEME_STORAGE_KEY = "theme";

export type ThemeProviderState = {
  theme: Theme;
  setTheme: (theme: Theme) => void;
};

const initialState: ThemeProviderState = {
  theme: "system",
  setTheme: () => null,
};

export const ThemeProviderContext =
  createContext<ThemeProviderState>(initialState);
